<template>
<div class="box">
  <div class="contain">
    <h2>登录/注册</h2>
    <input class="tel" type="tel" maxlength="13" v-model="usertel" placeholder="手机号">
    <div class="smcode">
      <input class="tel" type="tel" maxlength="6" v-model.trim="smcode" placeholder="验证码">
      <span :class="[isClick?'':'disable']" @click="getYZM">{{btnText}}</span>
    </div>
    <div class="agree_box">
      <div class="agree_left" @click="changeAgree">
        <img :src="!agreeOn?require('../assets/images/icon_check_normal.png'):require(`../assets/images/icon_check_${common.theme}.png`)" alt="">
      </div>
      <div class="agree_right">
        <p><span @click="changeAgree">本人已阅读并同意</span><router-link to="/Service" tag="i">《服务协议》</router-link><router-link to="/agreeMent" tag="i">《隐私政策》</router-link></p>
      </div>
    </div>
    <mt-button class="btn_login" @click="login">登录</mt-button>
    <!-- <img class="location" src="../assets/images/img_bg_signup.png" alt> -->
  </div>
  <div class="bg_i" v-if="common.theme != 1">
    <img src="../assets/images/login_bg.jpg" />
  </div>
  </div>
</template>

<script>
import util from '../utils/util'
import { sendMsgCode, login ,callSpaceUp} from '../utils/api'
import { mapState, mapActions } from 'vuex'
import storage from '../utils/storage'
let timer = ''
export default {
  name: 'Login',
  data () {
    return {
      btnText: '获取验证码',
      usertel: '',
      isClick: true,
      canClick: true,
      smcode: '',
      agreeOn: false
    }
  },
  computed: {
    ...mapState({
      common: state => state.common,
      marketInfo: state => state.common.marketInfo
    })
  },
  created () {
    if(storage.get("agreeOn")){
      this.agreeOn = true;
    }
  },
  methods: {
    ...mapActions(['getUserInfo', 'getUserId', 'getTenantInfo','getTenantInfoList',"getZiDianData"]),
    getComplainType() {
      let parmes = {
        companyId:this.common.userInfo.cityId,
        url: "/property/rstRepair/initDictWhenLoginName"
      }
      callSpaceUp(parmes).then(res => {
        console.log(res);
        if (res.res.code == 10000) {
          this.getZiDianData(res.body.data)//缓存全局字典
        }
      });
    },
    //   获取验证码
    getYZM () {
      if (this.isClick) {
        this.isClick = false
        if (this.usertel.length !== 11) {
          util.showToast('请输入正确的手机号')
          this.isClick = true
          return
        }
        let params = {
          account: this.usertel,
          type: 6
        }
        sendMsgCode(params).then(res => {
          if (res.res.code === 10000) {
            util.showToast('发送成功')
            this.leftTimer(59)
          }else{
            util.showToast(res.res.msg)
            this.btnText = '获取验证码'
            this.isClick = true
          }
          // this.isClick = true
        })
      }
    },
    changeAgree () {
      this.agreeOn = !this.agreeOn;
    },
    leftTimer (time) {
      clearTimeout(timer)
      time = time < 10 ? '0' + time : time
      if (time > 0) {
        this.btnText = time + ' s'
        time = time - 1
        timer = setTimeout(() => {
          this.leftTimer(time)
        }, 1000)
      } else {
        this.btnText = '获取验证码'
        this.isClick = true
      }
    },
    // 登录
    login () {
      if (!this.canClick) { return; }
      if (this.usertel.length !== 11) {
        util.showToast('请输入正确的手机号')
        return
      }
      if (!this.smcode.length) {
        util.showToast('请输入验证码')
        return
      }
      if (!this.agreeOn) {
        util.showToast('请阅读并同意协议')
        return
      }
      this.canClick = false;
      let params = {
        phone: this.usertel,
        regCode: this.smcode,
        openId: this.common.openId,
        marketId: this.marketInfo.id
      }
      let header = {}
      if(this.common.cityId){
        params.marketId = ''
        header.cityId = this.common.cityId
        header.marketId = ''
      }
      login(params,header).then(res => {
        console.log(res)
        if (res.res.code === 10000) {
          sessionStorage.removeItem('displayCondition');
          storage.set("agreeOn",true)
          storage.setS("userData",JSON.stringify(res.body))

          console.log('login userData ===' + JSON.stringify(res.body))

          if (res.body.userId) {
            this.getUserId(res.body.userId);
          }
          if (res.body.userInfo) {
            this.getUserInfo(res.body.userInfo);
          }
          // 默认企业
          if (res.body.userTenantInfo) {
            this.getTenantInfo(res.body.userTenantInfo);
          }
          // 如果有认证企业列表信息
          if (res.body.userTenantInfoList && res.body.userTenantInfoList.length) {
            this.getTenantInfoList(res.body.userTenantInfoList);
          }
          if (this.$route.query.Rurl) {
            var url =  this.$route.query.Rurl
            if(this.common.hasTsModule){
              if(url.indexOf('wuyeRepair') > -1){
                url =url+"?&showRepairSelect=1"
              }
            }
            this.$router.replace(url)
          } else if(this.$route.query.parkingSearch){
            this.$router.go(-1)
            this.$router.replace('/parkingSearch')
          }else {
            this.$router.replace('/')
          }
          this.getComplainType()//获取全局字典
          util.showToast('登录成功')
        } else {
          util.showToast(res.res.msg, 2000)
        }
        this.canClick = true;
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";
.box{
  background:@colore;
}
.contain {
  padding: 0 60px;
  padding-bottom:30px;
  margin:0 auto;
  overflow: hidden;
  position: relative;
  z-index:3;
  background:@colore;
}
h2 {
  font-size:36px;
  color: @color3;
  line-height: 50px;
  margin: 80px auto 60px;
  text-align:center;
}
.tel {
  display: block;
  width: 100%;
  background:#fff;
  height:88px;
  .fontSize(14px);
  color: @color3;
  border-radius:8px;
  margin-bottom: 20px;
  text-indent: 28px;
  background:#f9f9f9;
}
.smcode {
  position: relative;
  width: 100%;
  span {
    position: absolute;
    right: 0;
    top:0;
    display: block;
    width: 176px;
    height: 88px;
    text-align: center;
    line-height: 88px;
    .fontSize(12px);
    color: @color3;
    &.disable {
      color: #999;
      background:transparent;
    }
    &::after{
      position: absolute;left:0;top:26px;
      width:1px;
      height:36px;
      content:"";
      background:#c9c9c9;
    }
  }
}
.btn_login {
  height: 88px;
  display: block;
  width:100%;
  border-radius:8px;
  text-align: center;
  line-height: 88px;
  .fontSize(16px);
  color: rgba(255, 255, 255, 1);
  margin: 40px auto 0;
  display: block;
  .commonBg();
  box-shadow:0px 8px 16px 0px rgba(164,175,217,1);
}
.desc_text {
  color: @color9;
  text-align: center;
  .fontSize(14px);
  line-height: 40px;
  .service{
    color:@colorff;
  }
}
.location {
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translate(-50%);
  display: block;
  width: 522px;
  height: 400px;
}
// 协议
.agree_box{
  .flex();
  flex-wrap:wrap;
  margin-top:60px;
  .agree_left{
    width:32px;
    height:32px;
    margin-right:12px;
    span{
      display: block;
      width:32px;
      height:32px;
      border-radius:100%;
      .border();
      background:#fff;
    }
    img{
      display: block;
      width:32px;
      height:32px;
    }
  }
  .agree_right{
    flex:1;
    p{
      .fontSize(12px);
      display:inline-block;
      color:#333;
      line-height:34px;
      i{
        color:@color17;
      }
    }
  }
}
.bg_i{
  position:fixed;
  bottom:0;left:0;right:0;
  height:350px;
  z-index:2;
  display:flex;
  flex-direction:row;
  justify-content:center;
  img{
    display:block;
    height:350px;
    width:auto;
  }
}
</style>
